import { MonetaryInfo } from '@superbet-group/betting.lib.payments';
import { getConfig } from '@superbet-group/web.lib.config';
import { BetSlipPurchaseType } from '@superbet-group/web.types';
import { Dispatch } from 'vuex';

import i18n from '@app/localization/i18n';
import { BetSlipData } from '@core/models/betSlip/IBetSlip';
import OfferEvent from '@core/models/offer/OfferEvent';
import { PayoutService } from '@core/services/betSlip/PayoutService';
import { TaxService } from '@core/services/betSlip/TaxService';
import OfferService from '@core/services/offer/OfferService';
import { getMultiMarketSelectEnabledFlag } from '@sportOfferFederation/multi-market-select/featureToggle';
import { RelativeRootGetters } from '@store/types';

import { createBetSlipModule } from '../betSlip';
import { SseUpdate } from '@core/services/offer/_private/sse/types';

function getBetSlipModule(
    getMultiMarketSelectEnabledFlag: () => Promise<boolean>,
    roundToTwoDecimals: (value: number) => string,
) {
    return createBetSlipModule({
        subscribeToEvent: (eventId: number, callback: (match: SseUpdate<OfferEvent>) => void) => OfferService.getInstance().subscribeToEvent(eventId, callback),
        getEvents: (eventIds: number[]) => OfferService.getInstance().getEventsById(eventIds),
        getPayout: (betSlipData: BetSlipData, monetaryInfo: MonetaryInfo) => {
            return Promise.resolve(PayoutService.getInstance().getPayout(betSlipData, monetaryInfo));
        },
        getDefaultStake() {
            return getConfig().betSlip.defaultStake || getConfig().betSlip.stakeMin;
        },
        calculateNetStake(stake: number, purchaseType: BetSlipPurchaseType) {
            const taxService = TaxService.getInstance();
            return taxService.getNetStake(stake, purchaseType);
        },
        async getMatch(dispatch: Dispatch, rootGetters: RelativeRootGetters, id: number) {
            await dispatch('data/sportOffer/getEvent', id, { root: true });
            return rootGetters['data/sportOffer/eventsMap'][id];
        },
        getUser(rootGetters: RelativeRootGetters) {
            return rootGetters['data/authentication/user'];
        },
        maxSystemsCount: 16,
        getMultiMarketSelectEnabledFlag,
        roundToTwoDecimals,
    });
}

export const betSlipModule = getBetSlipModule(
    getMultiMarketSelectEnabledFlag,
    (value: number) => i18n.n(value, 'decimal', getConfig().appLocale.localeNumberOverride),
);

export type BetSlipModule = typeof betSlipModule;
